export const GET_VENDOR_TABLE_DATA = 'GET_VENDOR_TABLE_DATA'
export const GET_VENDOR_TABLE_DATA_ERR = 'GET_VENDOR_TABLE_DATA_ERR'

export const GET_VENDOR_REPORT_STATS = 'GET_VENDOR_REPORT_STATS';
export const GET_VENDOR_REPORT_STATS_ERR = 'GET_VENDOR_REPORT_STATS_ERR';